// frontend/src/components/ETADisplay/StatusViews.js
// Components for various status displays (loading, error, canceled, no data, waiting for GPS)

import React from 'react';
import { Loader, AlertTriangle, XCircle, Navigation } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';

export const LoadingView = () => {
    const { t } = useTranslation();
    const { text, components, cn } = useTheme();

    return (
        <div className={cn(
            "rounded-lg border p-4 flex items-center justify-center",
            components.card.base,
            text.secondary
        )}>
            <Loader className="h-5 w-5 animate-spin mr-2" />
            <span>{t('Loading ETA...')}</span>
        </div>
    );
};

export const ErrorView = ({ error }) => {
    const { t } = useTranslation();
    const { border, semantic, cn } = useTheme();

    return (
        <div className={cn(
            "rounded-lg border p-4 flex items-center",
            semantic.error,
            border.error
        )}>
            <AlertTriangle className="h-5 w-5 mr-2" />
            <span>{error.message || String(error)}</span>
        </div>
    );
};

export const CanceledTripView = () => {
    const { t } = useTranslation();
    const { text, background, components, cn } = useTheme();

    return (
        <div className={cn(
            "rounded-lg border overflow-hidden",
            components.card.base
        )}>
            <div className={cn(
                "px-4 py-3 border-b flex items-center",
                background.secondary
            )}>
                <XCircle className="h-5 w-5 mr-2" />
                <h3 className={cn("font-medium", text.primary)}>{t('Trip Canceled')}</h3>
            </div>
            <div className={cn("p-4 text-center", text.muted)}>
                {t('No ETA data available for canceled trip')}
            </div>
        </div>
    );
};

export const WaitingForGPSView = () => {
    const { t } = useTranslation();
    const { background, border, cn } = useTheme();

    return (
        <div className={cn(
            "rounded-lg border p-4",
            background.secondary,
            border.default
        )}>
            <div className="flex items-center justify-center">
                <Navigation className="h-5 w-5 animate-pulse mr-2" />
                <span>{t('Calculating GPS-based ETA...')}</span>
            </div>
        </div>
    );
};

export const NoDataView = ({ displayData, tripData, isDriver }) => {
    const { t } = useTranslation();
    const { text, components, cn } = useTheme();

    const message = displayData?.type === 'no_data'
        ? t('No ETA data available')
        : tripData?.status === 'in_progress' || isDriver
            ? t('Waiting for GPS data to calculate ETA...')
            : t('No ETA data available');

    return (
        <div className={cn(
            "rounded-lg border p-4 text-center",
            components.card.base,
            text.muted
        )}>
            {message}
        </div>
    );
};